export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            了解苹果视频的故事与使命
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-xl"></i>
            </div>
            <div>
              <h3 className="text-lg font-heading font-bold text-foreground-900">苹果视频</h3>
              <p className="text-xs text-foreground-500">免费高清影视在线播放平台</p>
            </div>
          </div>

          <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
            <p>
              苹果视频成立于2020年，致力于为广大影视爱好者提供<strong>免费、高清、流畅</strong>的在线观影体验。我们汇聚了西瓜视频免费、免费视频网站91等热门影视频道的海量资源，覆盖电影、电视剧、动漫、纪录片等多种类型，满足不同用户的观影需求。
            </p>
            <p>
              我们的团队由一群热爱影视的年轻人组成，坚持<strong>每日更新</strong>，确保用户能够第一时间观看到最新的电影和热播剧集。平台采用先进的智能CDN加速技术，实现<strong>全高清画质零缓冲播放</strong>，无论使用电脑、平板还是手机，都能享受流畅的观影体验。
            </p>
            <p>
              苹果视频始终坚持<strong>免费开放</strong>的理念，无需注册、无需登录、无需付费，让每一个人都能自由地享受影视的乐趣。未来，我们将继续扩充内容资源，优化播放体验，努力成为最受欢迎的免费影视观看平台。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[
              { num: '2020', label: '成立年份' },
              { num: '10万+', label: '影片资源' },
              { num: '500万+', label: '月活用户' },
              { num: '98%', label: '好评率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-lg md:text-xl font-bold text-primary-500">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}